import { render } from "./ViewAboutUs.vue?vue&type=template&id=34b41804"
import script from "./ViewAboutUs.vue?vue&type=script&lang=js"
export * from "./ViewAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__